import { render, staticRenderFns } from "./MyPQTOffer.vue?vue&type=template&id=2df28588"
import script from "./MyPQTOffer.vue?vue&type=script&lang=js"
export * from "./MyPQTOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports